import { useEffect } from "react";
import { useDispatch } from "react-redux";

import * as actions from "../store/actions";
import { setUser } from "../store/features/users";
import { connect, disconnect, getSocket } from "../pusher";
import syncAll from "../utils/syncAll";

const useSubscriptions = (serviceProviderId) => {
  const dispatch = useDispatch();
  const channelNames = {
    dars: `${serviceProviderId}_daily-activity-report`,
    properties: `${serviceProviderId}_property`,
    propertyEvents: `${serviceProviderId}_property-event`,
    users: `${serviceProviderId}_service-provider-user`,
  };
  useEffect(() => {
    if (serviceProviderId) {
      connect();
      const socket = getSocket();
      socket.connection.bind("connected", () => syncAll(serviceProviderId));
      const darsChannel = socket.subscribe(channelNames.dars);
      darsChannel.bind("daily-activity-report", (data) => {
        dispatch(actions.dars.setDar(data));
      });
      const propertiesChannel = socket.subscribe(channelNames.properties);
      propertiesChannel.bind("property", (data) => {
        dispatch(actions.properties.setProperty(data));
      });
      const propertyEventsChannel = socket.subscribe(
        channelNames.propertyEvents
      );
      propertyEventsChannel.bind("property-event", (data) => {
        dispatch(actions.properties.setPropertyEvent(data));
      });
      const usersChannel = socket.subscribe(channelNames.users);
      usersChannel.bind("service-provider-user", (data) => {
        dispatch(setUser({ user: data }));
      });
    }
    return () => {
      disconnect();
    };
  }, [serviceProviderId]);
};

export default useSubscriptions;
